var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"fc-icon",style:([_vm.style])},[(_vm.can_load_img)?_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }